import { useNavigate, useSearchParams } from 'react-router-dom';
import { RADAR_TEMPLATE } from '@/consts/searchKeys';
import { useUpdateQueryString } from './useUpdateQueryString';

export const useNavigateToRadarTemplateId = () => {
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const navigate = useNavigate();

  return (id: string) => {
    const keysToAdd = [{ key: RADAR_TEMPLATE, value: id }];

    const newQueryString = updateQueryString(keysToAdd);
    navigate(`?${newQueryString}`);
  };
};
